import { render, staticRenderFns } from "./ApplicantEmergencyContacts.vue?vue&type=template&id=b8aa109a&scoped=true&"
import script from "./ApplicantEmergencyContacts.vue?vue&type=script&lang=js&"
export * from "./ApplicantEmergencyContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aa109a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
